import { Component, EventEmitter, Input, OnInit, OnDestroy, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Currency } from 'src/app/models/Lookup';
import { LookupsService } from 'src/app/services/lookups.service';
import { CheckOutService } from 'src/app/shared/check-out/CheckOut.service';
import { CheckOutActions } from 'src/app/shared/check-out/CheckOutActions';
import Swal from 'sweetalert2';
import { ReservationsService } from '../../services/reservations.service';
import { ChangeTableComponent } from '../listing/floor-view/change-table/change-table.component';
import { orderDetails, ReservationDetails, ReservationStatusEnum, Roles } from '../../models/Reservation';
import { ReassignServerComponent } from './reassign-server/reassign-server.component';
import { Subscription } from 'rxjs';
import { OrderItemStatusEnum } from 'src/app/features/orders/models/Orders';
import { PlaceOrderService } from 'src/app/features/place-order/services/placeOrder.service';
import { SignalRService } from 'src/app/services/signalR/SignalR.service';
import { SignalEventType } from 'src/app/services/signalR/SignalModel';

@Component({
  selector: 'app-reservation-details',
  templateUrl: './reservation.details.component.html'
})
export class ReservationDetailsComponent extends CheckOutActions implements OnInit, OnDestroy {
  @Input() restaurantId!: any;
  @Input() selectedReservationId!: number | null;
  @Input() viewType!: any;
  @Input() orderNumber!: number;
  @Input() canEdit = true;
  dataLoading = false;
  loading = false;
  btnLoading = false;
  updateLoading = false;
  loadingType!: string;
  @Output() close = new EventEmitter<boolean>();
  activeOrder!: orderDetails

  details!: ReservationDetails

  RestaurantServer!: boolean;

  totalCartPrice: any = []
  totalPrice = 0
  defaultCurrency!: any;

  timeDuration = {
    value: 0,
    duration: ''
  }

  subscriptions: Subscription[] = []

  constructor(
    private reservationService: ReservationsService,
    translate: TranslateService,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private lookupsService: LookupsService,
    checkoutService: CheckOutService,
    private service: PlaceOrderService,
    private signal: SignalRService
  ) {
    super(checkoutService, translate)
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.UpdateReservation)
        .subscribe(message => { this.signalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.kdsItemStatusChanged)
        .subscribe(message => { this.signalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.newOrderToKds)
        .subscribe(message => { this.newOrderToKdsSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.orderStatusChanged)
        .subscribe(message => { this.orderStatusSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.kdsItemStatusChanged)
        .subscribe(message => { this.kdsItemStatusSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.editOrder)
        .subscribe(message => { this.editOrderSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.cancelledOrder)
        .subscribe(message => { this.cancelledOrderSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.recallOrder)
        .subscribe(message => { this.recallOrderSignalAction(message.data); })
    )
    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.wasteOrder)
        .subscribe(message => { this.wasteOrderSignalAction(message.data); })
    )
  }

  signalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
      // const order = this.details.orderDetails?.find(order => order.orderId == OrderId)
      // if (order) {
      //   let itemIndx = order.orderItems.findIndex(item => item.id == ItemId);
      //   if (itemIndx != -1) {
      //     order.orderItems[itemIndx].status = NewStatus
      //   }
      // }
    }
  }
  newOrderToKdsSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }
  orderStatusSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }

  kdsItemStatusSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }
  editOrderSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }
  cancelledOrderSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }
  recallOrderSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }
  wasteOrderSignalAction(data: any) {
    if (data.RestaurantId == this.restaurantId && data.ReservationId == this.selectedReservationId) {
      this.getDetails();
    }
  }

  ngOnInit(): void {
    this.getDetails();
    this.subscriptions.push(
      this.checkoutService.refreshView.subscribe(data => {
        if (data) { this.getDetails(); }
      })
    )
    this.subscriptions.push(
      this.reservationService.refreshList.subscribe(data => {
        if (data) {
          this.getDetails();
        }
      })
    )
    this.subscriptions.push(
      this.reservationService.closeDetails.subscribe(data => {
        if (data) {
          this.close.emit();
          this.reservationService.closeDetails.next(false);
        }
      })
    )
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('view')) {
        this.viewType = params.get('view') || 'list';
      }
    });
  }

  DefaultCurrency() {
    this.lookupsService.RestaurantDefaultCurrency(this.restaurantId)
      .subscribe(
        data => {
          this.defaultCurrency = data as Currency;
        }, err => {
          console.error(err);
        });
  }

  calcDurationM(minutes: any) {
    minutes = Number(minutes)
    return minutes + ' ' + this.translate.instant('placeOrder.mins')
  }

  ngOnDestroy() {
    this.reservationService.refreshList.next(false);
    this.reservationService.closeDetails.next(false);
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  getDetails() {
    this.dataLoading = true
    this.reservationService.GetReservationById(this.selectedReservationId).subscribe((data: any) => {
      this.details = data;
      if (this.details.reservationDuration) {
        this.details.reservationDuration = Number(this.details.reservationDuration)
        this.timeDuration = {
          value: this.details.reservationDuration,
          duration: this.calcDuration(this.details.reservationDuration)
        }
      }
      this.details?.orderDetails?.forEach(kitchen => {
        kitchen.orderItems.forEach((element: any) => {
          element.currentPreparationTime = Math.floor(element.currentPreparationTime);
          element.preparingTimer = this.getElapsedTime(element.currentPreparationTime);
          if (element.currentPreparationTime >= 0) {
            window.setInterval(() => {
              element.currentPreparationTime = element.currentPreparationTime - 1;
              element.preparingTimer = this.getElapsedTime(element.currentPreparationTime);
            }, 1000)
          }
        });
      });

      this.dataLoading = false;
      if (!this.restaurantId) {
      }
      this.restaurantId = this.details.restaurantId
      localStorage.setItem('restaurantId', this.restaurantId);
      this.DefaultCurrency();

      this.RestaurantServer = this.details.currentUserRoles.some((user: Roles) => user.roleType == 'RestaurantServer')
      if (this.details.orderDetails?.length) {
        this.activeOrder = this.details.orderDetails.find(order => order.orderNumber == this.orderNumber) || data.orderDetails[this.details.orderDetails.length - 1];
        this.changeActiveOrder(this.activeOrder);
      }
      // Calculate Price of Cart items
      // this.totalCartPrice = []
      // this.totalCartPrice.push(this.details.orderDetails?.orderItems.map((item) => item.price))
      // this.totalCartPrice?.forEach((number: any) => {
      //   this.totalCartPrice = number;
      // })
      // this.totalPrice = this.totalCartPrice?.reduce((acc: number, cur: number) => acc + cur, 0);
    }, error => {
      this.dataLoading = false;
      this.closeDetails();
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    })
  }

  openChangeTable() {
    const dialogRef = this.dialog.open(ChangeTableComponent, {
      width: '980px',
      data: {
        reservationId: this.selectedReservationId,
        restaurantId: this.restaurantId,
        floorId: this.details.floorId,
        tablesToSelect: this.details.tabels
      }
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  calcDuration(value: number) {
    let minutes = value
    const hours = Math.floor(minutes / 60);
    const minutesLeft = minutes % 60;
    return `${hours}hr, ${minutesLeft}m`
  }

  getElapsedTime(allSeconds: number) {
    let minutes = 0;
    let seconds = 0;
    let totalSeconds = allSeconds;
    let isNegative = false;

    if (allSeconds < 0) return { m: 0, s: 0, totalSeconds: allSeconds, isNegative }
    if (allSeconds < 0) {
      isNegative = true;
      totalSeconds = Math.abs(allSeconds);
    }

    let m = '00', s = '00';

    if (totalSeconds >= 60) {
      minutes = Math.floor(totalSeconds / 60);
      m = minutes > 9 ? "" + minutes : "0" + minutes;
      totalSeconds -= 60 * minutes;
    }

    seconds = totalSeconds;
    s = seconds > 9 ? "" + seconds : "0" + seconds;

    return { m, s, totalSeconds: allSeconds, isNegative };
  }

  removeStoredOrder() {
    let orders: any = localStorage.getItem('orders');
    orders = orders ? JSON.parse(orders) : [];
    let storedOrders = orders.filter((order: any) => order.reservationId != this.selectedReservationId);
    localStorage.setItem('orders', JSON.stringify(storedOrders));
  }
  changeStatus(status: any) {
    let data = {
      restaurantId: this.restaurantId,
      reservationId: this.selectedReservationId,
      reservationStatus: status
    }

    let confirmMsg;
    let confirmTitle;
    if (status == ReservationStatusEnum.Cancelled) {
      confirmMsg = this.translate.instant('swalMsg.cancelConfirm');
      confirmTitle = this.translate.instant('swalMsg.CancelReservation');
    } else {
      confirmMsg = this.translate.instant('swalMsg.changeStatusConfirm');
      confirmTitle = this.translate.instant('swalMsg.changeStatus');
    }
    // Confirmation
    Swal.fire({
      title: confirmTitle,
      text: confirmMsg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No'),
    }).then((result) => {
      if (result.value) {
        if (
          status == ReservationStatusEnum.Cancelled
          || status == ReservationStatusEnum.Released
        ) {
          this.removeStoredOrder();
        }
        this.btnLoading = true;
        this.loadingType = status;
        this.reservationService.ResChangeReservationStatus(data).subscribe((res: any) => {
          let msg = this.translate.instant('swalMsg.savedsuccessfully');
          this.btnLoading = false;
          this.loadingType = '';
          Swal.fire({
            title: this.translate.instant('swalMsg.Success'),
            text: msg,
            icon: 'success',
            confirmButtonText: this.translate.instant('swalMsg.Ok')
          });
          this.reservationService.refreshList.next(true);
        }, error => {
          this.btnLoading = false;
          this.loadingType = '';
          Swal.fire({
            title: this.translate.instant('swalMsg.Failed'),
            text: error.detail,
            icon: 'error',
            confirmButtonText: this.translate.instant('swalMsg.Ok'),
          });
        });
      }
    })

  }

  checkAvailabilityOfButtons() {
    return this.details.canArrived ||
      this.details.canCancelled ||
      this.details.canNoShow ||
      this.details.canReleased ||
      this.details.canSeated;
  }


  openAssignServer() {
    const dialogRef = this.dialog.open(ReassignServerComponent, {
      width: '50rem',
      data: {
        reservation: this.details,
        reservationId: this.selectedReservationId,
        restaurantId: this.restaurantId
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getDetails()
      }
    });
  }

  editDuration(operator: string) {
    if (operator === '+') {
      this.timeDuration.value = this.timeDuration.value + 15,
        this.timeDuration.duration = this.calcDuration(this.timeDuration.value)
    }
    if (operator === '-') {
      this.timeDuration.value = this.timeDuration.value - 15,
        this.timeDuration.duration = this.calcDuration(this.timeDuration.value)
    }
  }

  updateExtendedDuration() {
    this.updateLoading = true;
    this.reservationService.ResReservationExtendDuration(this.selectedReservationId, this.timeDuration.value).subscribe((data) => {
      if (data) {
        this.updateLoading = false;
        Swal.fire({
          title: this.translate.instant('swalMsg.Success'),
          text: this.translate.instant('swalMsg.savedsuccessfully'),
          icon: 'success',
          confirmButtonText: this.translate.instant('swalMsg.Ok'),
        });
        this.getDetails()
      }
    }, error => {
      this.updateLoading = false;
      Swal.fire({
        title: this.translate.instant('swalMsg.Failed'),
        text: error.detail,
        icon: 'error',
        confirmButtonText: this.translate.instant('swalMsg.Ok'),
      });
    })
  }

  changeActiveOrder(order: orderDetails) {
    this.currentOrderId = order.orderId;
    this.activeOrder = order;
    this.currency = this.activeOrder.currency;
    this.currentOrderId = this.activeOrder.orderId;
    if (this.currentOrderId && this.activeOrder.canCheckout) {
      this.ResGetDiscountList();
    }
  }

  closeDetails() {
    if (this.timeDuration.value && (this.timeDuration.value != this.details.reservationDuration)) {
      Swal.fire({
        title: this.translate.instant('swalMsg.are you sure you want to discard all the changes'),
        text: '',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: this.translate.instant('swalMsg.Yes'),
        cancelButtonText: this.translate.instant('swalMsg.No'),
      }).then((result) => {
        if (result.value) {
          this.close.emit();
          return true;
        } else {
          return false;
        }
      })
    } else {
      this.close.emit();
    }
  }


  changeItemStatus(itemId: number) {
    Swal.fire({
      title: this.translate.instant('placeOrder.Confirm Serving?'),
      text: '',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('swalMsg.Yes'),
      cancelButtonText: this.translate.instant('swalMsg.No')
    }).then((result) => {
      if (result.value) {
        this.actionLoading = true;
        let data = {
          status: OrderItemStatusEnum.Served,
          reservationId: this.selectedReservationId,
          menuItemReservationId: itemId,
          orderId: this.activeOrder?.orderId
        }
        this.service.ResChangeItemStatus(data).subscribe(
          (data: any) => {
            this.actionLoading = false;
            if (data) {
              Swal.fire({
                title: this.translate.instant('swalMsg.Success'),
                text: this.translate.instant('swalMsg.updatedsuccessfully'),
                icon: 'success',
                confirmButtonText: this.translate.instant('swalMsg.Ok')
              });
              this.getDetails()
            }
          },
          (error: any) => {
            this.actionLoading = false;
            Swal.fire({
              title: this.translate.instant('swalMsg.Failed'),
              text: error.detail,
              icon: 'error',
              confirmButtonText: this.translate.instant('swalMsg.Ok'),
            });
          })
      }
    });
  }
}
